import { forwardRef } from 'react';

import clsx from 'clsx';

import { body } from './Modal.css';
import { ModalBodyProps } from './types';
import { Scrollbar } from '../Scrollbar';

export const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Scrollbar
        style={{ maxHeight: 'inherit' }}
        translateContentSizeYToHolder
        contentProps={{
          style: { display: 'flex' },
        }}
        trackXOffset={{
          right: 12,
        }}
        trackYOffset={{
          bottom: 12,
        }}
      >
        <div ref={ref} className={clsx(body, className)} {...props}>
          {children}
        </div>
      </Scrollbar>
    );
  },
);

ModalBody.displayName = 'ModalBody';
